import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaArrowLeft, FaCheckCircle, FaExclamationCircle, FaKey, FaSyncAlt, FaArrowRight } from "react-icons/fa";
import { useBaseUrl } from "../Contexts/BaseUrlContext";

const CSS = `
div.fixed.right-4.bottom-4 { display: none !important; }

/* ---------- animated scene ---------- */
.lg-scene { background: #070b1f; }
.lg-aurora { position: absolute; border-radius: 9999px; filter: blur(80px); mix-blend-mode: screen; opacity: .55; }
.lg-a1 { width: 55vw; height: 45vh; left: -10vw; top: -12vh; background: #0ea5e9; animation: lgDrift1 18s ease-in-out infinite; }
.lg-a2 { width: 50vw; height: 50vh; right: -12vw; top: 5vh; background: #8b5cf6; animation: lgDrift2 22s ease-in-out infinite; }
.lg-a3 { width: 60vw; height: 40vh; left: 20vw; bottom: -18vh; background: #ec4899; opacity: .35; animation: lgDrift3 26s ease-in-out infinite; }
@keyframes lgDrift1 { 0%,100% { transform: translate(0,0) scale(1); } 50% { transform: translate(12vw,8vh) scale(1.15); } }
@keyframes lgDrift2 { 0%,100% { transform: translate(0,0) scale(1); } 50% { transform: translate(-14vw,10vh) scale(.9); } }
@keyframes lgDrift3 { 0%,100% { transform: translate(0,0); } 50% { transform: translate(-10vw,-6vh); } }
.lg-floor { position: absolute; left: -50%; right: -50%; bottom: -12%; height: 52%; transform: perspective(600px) rotateX(64deg); transform-origin: bottom; background-image: linear-gradient(rgba(148,163,255,.28) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,255,.28) 1px, transparent 1px); background-size: 64px 64px; mask-image: linear-gradient(to top, black 5%, transparent 80%); -webkit-mask-image: linear-gradient(to top, black 5%, transparent 80%); animation: lgFloor 5s linear infinite; }
@keyframes lgFloor { to { background-position: 0 64px, 0 0; } }
.lg-horizon { position: absolute; left: 0; right: 0; top: 58%; height: 1px; background: linear-gradient(90deg, transparent, rgba(125,211,252,.9), rgba(192,132,252,.9), transparent); box-shadow: 0 0 40px 8px rgba(139,92,246,.35); }
.lg-star { position: absolute; width: 2px; height: 2px; border-radius: 9999px; background: white; animation: lgTwinkle 3s ease-in-out infinite; }
@keyframes lgTwinkle { 0%,100% { opacity: .15; } 50% { opacity: .9; } }
.lg-shoot { position: absolute; width: 120px; height: 2px; background: linear-gradient(90deg, white, transparent); border-radius: 9999px; opacity: 0; transform: rotate(-20deg); animation: lgShoot 7s ease-in infinite; }
@keyframes lgShoot { 0% { opacity: 0; transform: translate(0,0) rotate(-20deg); } 3% { opacity: 1; } 12% { opacity: 0; transform: translate(-360px,130px) rotate(-20deg); } 100% { opacity: 0; } }
.lg-mote { position: absolute; bottom: -10px; width: 6px; height: 6px; border-radius: 9999px; background: radial-gradient(circle, rgba(196,181,253,.9), transparent 70%); animation: lgRise linear infinite; }
@keyframes lgRise { from { transform: translateY(0); opacity: 0; } 15% { opacity: 1; } to { transform: translateY(-80vh); opacity: 0; } }

/* ---------- entrance ---------- */
.lg-duo { animation: lgPushIn 2.2s cubic-bezier(.25,.8,.25,1) both; }
@keyframes lgPushIn { 0% { transform: translateX(-110vw); } 80% { transform: translateX(12px); } 100% { transform: translateX(0); } }

/* ---------- card ---------- */
.lg-card { background: linear-gradient(180deg, rgba(17,24,52,.78), rgba(10,14,34,.82)); border: 1px solid rgba(255,255,255,.1); box-shadow: 0 40px 90px -30px rgba(0,0,0,.8), inset 0 1px 0 rgba(255,255,255,.08); backdrop-filter: blur(18px); -webkit-backdrop-filter: blur(18px); }
.lg-card::before { content: ""; position: absolute; inset: -1px; border-radius: inherit; padding: 1px; background: linear-gradient(135deg, rgba(56,189,248,.7), rgba(139,92,246,.2) 40%, rgba(236,72,153,.6)); -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none; }
.lg-field { background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.12); transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease; }
.lg-field:hover { border-color: rgba(255,255,255,.22); }
.lg-field:focus-within { background: rgba(255,255,255,.08); border-color: #8b5cf6; box-shadow: 0 0 0 4px rgba(139,92,246,.22); }
.lg-field.lg-bad { border-color: #f43f5e; box-shadow: 0 0 0 4px rgba(244,63,94,.18); }
.lg-btn { background-image: linear-gradient(90deg, #7c3aed, #2563eb, #7c3aed); background-size: 200% 100%; transition: background-position .5s ease, transform .15s ease, box-shadow .2s ease; box-shadow: 0 10px 30px -10px rgba(124,58,237,.8); }
.lg-btn:hover { background-position: 100% 0; }
.lg-btn:active { transform: scale(.985); }
.lg-btn .lg-arrow { transition: transform .2s ease; }
.lg-btn:hover .lg-arrow { transform: translateX(3px); }
.lg-step { animation: lgStep .35s cubic-bezier(.2,.8,.2,1) both; }
@keyframes lgStep { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
.lg-shake { animation: lgShake .4s ease; }
@keyframes lgShake { 0%,100% { transform: translateX(0); } 20%,60% { transform: translateX(-7px); } 40%,80% { transform: translateX(7px); } }

/* ---------- mascot ---------- */
.m-arm { transition: transform .45s cubic-bezier(.3,1.4,.5,1); transform-box: fill-box; transform-origin: 50% 8%; }
.m-head { transform-box: fill-box; transform-origin: 50% 90%; transition: transform .35s ease; }
.m-legL, .m-legR { transform-box: fill-box; transform-origin: 50% 0%; }
.m-body { transform-box: fill-box; transform-origin: 50% 100%; }
.m-eyes { transition: transform .3s ease; }

.st-push .m-legL { animation: mWalk .45s ease-in-out infinite; }
.st-push .m-legR { animation: mWalk .45s ease-in-out infinite reverse; }
.st-push .m-body { animation: mBob .45s ease-in-out infinite; }
@keyframes mWalk { 0%,100% { transform: rotate(18deg); } 50% { transform: rotate(-18deg); } }
@keyframes mBob { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
.st-push .m-armL { transform: rotate(-78deg); }
.st-push .m-armR { transform: rotate(-88deg); }
.st-push .m-head { transform: rotate(8deg); }

/* idle: breathes, looks around, waves, rests on card, points up, taps foot */
.st-idle .m-body { animation: mBreath 3s ease-in-out infinite; }
@keyframes mBreath { 0%,100% { transform: scaleY(1); } 50% { transform: scaleY(1.025); } }
.st-idle .m-head { animation: mLook 7s ease-in-out infinite; }
@keyframes mLook { 0%,20%,100% { transform: rotate(0deg); } 30%,45% { transform: rotate(9deg); } 55%,70% { transform: rotate(-7deg); } }
.st-idle .m-eyes { animation: mEyes 7s ease-in-out infinite; }
@keyframes mEyes { 0%,20%,100% { transform: translateX(0); } 30%,45% { transform: translateX(4px); } 55%,70% { transform: translateX(-4px); } }
.st-idle .m-armL { transform: rotate(8deg); }
.st-idle .m-armR { animation: mIdleArm 9s ease-in-out infinite; }
@keyframes mIdleArm {
  0% { transform: rotate(-150deg); } 6% { transform: rotate(-125deg); } 12% { transform: rotate(-150deg); } 18% { transform: rotate(-125deg); } 24% { transform: rotate(-150deg); }
  32%,58% { transform: rotate(-85deg); }
  66%,88% { transform: rotate(-168deg); }
  100% { transform: rotate(-150deg); }
}
.st-idle .m-legR { animation: mTap 9s ease-in-out infinite; }
@keyframes mTap { 0%,34%,58%,100% { transform: rotate(0deg); } 38%,46%,54% { transform: rotate(-10deg); } 42%,50% { transform: rotate(0deg); } }

/* watching the email being typed */
.st-watch .m-armL { transform: rotate(8deg); }
.st-watch .m-armR { transform: rotate(-85deg); }
.st-watch .m-head { transform: rotate(10deg); }
.st-watch .m-eyes { transform: translate(5px, 2px); }
.st-watch .m-body { animation: mBreath 3s ease-in-out infinite; }

.st-cover .m-armL { transform: rotate(-155deg); }
.st-cover .m-armR { transform: rotate(155deg); }
.st-cover .m-head { transform: rotate(-4deg) translateY(2px); }

.st-no .m-armL { transform: rotate(10deg); }
.st-no .m-armR { animation: mWag .35s ease-in-out infinite; }
.st-no .m-head { animation: mShake .5s ease-in-out infinite; }
@keyframes mWag { 0%,100% { transform: rotate(-168deg); } 50% { transform: rotate(-148deg); } }
@keyframes mShake { 0%,100% { transform: rotate(0deg); } 25% { transform: rotate(-12deg); } 75% { transform: rotate(12deg); } }

.st-yay .m-armL { transform: rotate(150deg); }
.st-yay .m-armR { transform: rotate(-150deg); }
.st-yay { animation: mJump .6s ease-in-out 3; }
@keyframes mJump { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-18px); } }

.m-blink { animation: mBlink 4s infinite; transform-box: fill-box; transform-origin: center; }
@keyframes mBlink { 0%,92%,100% { transform: scaleY(1); } 95% { transform: scaleY(.1); } }

.lg-bubble { animation: lgBubble .35s cubic-bezier(.3,1.5,.5,1) both; }
@keyframes lgBubble { from { opacity: 0; transform: translateY(8px) scale(.85); } to { opacity: 1; transform: none; } }

@media (prefers-reduced-motion: reduce) {
  .lg-aurora, .lg-floor, .lg-star, .lg-shoot, .lg-mote, .lg-duo, .m-arm, .m-legL, .m-legR, .m-body, .m-head, .m-eyes, .m-blink, .lg-bubble, .lg-step, .lg-shake, .st-yay { animation: none !important; }
}
`;

const MOTES = Array.from({ length: 14 }, (_, i) => ({ left: `${(i * 61) % 100}%`, delay: `${(i * 1.3) % 10}s`, dur: `${10 + ((i * 5) % 9)}s` }));
const STARS = Array.from({ length: 30 }, (_, i) => ({ left: `${(i * 37) % 100}%`, top: `${(i * 23) % 50}%`, delay: `${(i % 7) * 0.4}s` }));

// Only the round emblem from ycnp.png, without the YCNP text
const LogoMark = ({ size = 40 }) => (
  <span className="relative block rounded-full overflow-hidden bg-white shrink-0" style={{ width: size, height: size }}>
    <img src="/ycnp.png" alt="YCNP" draggable="false" style={{ position: "absolute", height: "100%", width: "auto", maxWidth: "none", left: 0, top: 0 }} />
  </span>
);

/* A friendly 3D-style mascot drawn in SVG. Its pose changes with `state`. */
const Mascot = ({ state }) => (
  <svg viewBox="0 0 200 300" width="190" height="285" className={`st-${state} overflow-visible`} aria-hidden="true">
    <defs>
      <radialGradient id="mSkin" cx="40%" cy="35%" r="70%">
        <stop offset="0%" stopColor="#ffe0c2" />
        <stop offset="60%" stopColor="#f5b98a" />
        <stop offset="100%" stopColor="#d98b5f" />
      </radialGradient>
      <linearGradient id="mHood" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#fb923c" />
        <stop offset="55%" stopColor="#f97316" />
        <stop offset="100%" stopColor="#c2410c" />
      </linearGradient>
      <linearGradient id="mPants" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#334155" />
        <stop offset="100%" stopColor="#0f172a" />
      </linearGradient>
      <radialGradient id="mHair" cx="40%" cy="30%" r="80%">
        <stop offset="0%" stopColor="#4b3a2f" />
        <stop offset="100%" stopColor="#1c1410" />
      </radialGradient>
    </defs>

    {/* floor shadow */}
    <ellipse cx="100" cy="290" rx="62" ry="9" fill="rgba(0,0,0,.35)" />

    {/* back arm */}
    <g className="m-arm m-armL">
      <rect x="54" y="120" width="22" height="78" rx="11" fill="url(#mHood)" />
      <circle cx="65" cy="200" r="12" fill="url(#mSkin)" />
    </g>

    {/* legs */}
    <g className="m-legL">
      <rect x="72" y="214" width="24" height="62" rx="11" fill="url(#mPants)" />
      <ellipse cx="86" cy="280" rx="18" ry="8" fill="#e2e8f0" />
    </g>
    <g className="m-legR">
      <rect x="104" y="214" width="24" height="62" rx="11" fill="url(#mPants)" />
      <ellipse cx="118" cy="280" rx="18" ry="8" fill="#f8fafc" />
    </g>

    {/* body */}
    <g className="m-body">
      <rect x="62" y="112" width="76" height="112" rx="32" fill="url(#mHood)" />
      <path d="M78 150 Q100 162 122 150" stroke="rgba(0,0,0,.18)" strokeWidth="3" fill="none" strokeLinecap="round" />
      <circle cx="100" cy="185" r="13" fill="rgba(255,255,255,.9)" />
      <text x="100" y="190" textAnchor="middle" fontSize="12" fontWeight="900" fill="#dc2626">
        NP
      </text>
      <ellipse cx="84" cy="130" rx="14" ry="8" fill="rgba(255,255,255,.18)" />
    </g>

    {/* head */}
    <g className="m-head">
      <circle cx="100" cy="72" r="44" fill="url(#mSkin)" />
      <path d="M58 64 Q60 26 100 24 Q142 26 143 66 Q128 46 100 48 Q74 46 58 64 Z" fill="url(#mHair)" />
      <ellipse cx="58" cy="76" rx="7" ry="10" fill="#e9a57a" />
      <ellipse cx="142" cy="76" rx="7" ry="10" fill="#e9a57a" />
      {/* eyes */}
      <g className="m-eyes"><g className="m-blink">
        <ellipse cx="84" cy="74" rx="6" ry={state === "no" ? 4 : 7} fill="#1e293b" />
        <ellipse cx="116" cy="74" rx="6" ry={state === "no" ? 4 : 7} fill="#1e293b" />
        <circle cx="86" cy="71" r="2" fill="white" />
        <circle cx="118" cy="71" r="2" fill="white" />
      </g></g>
      {state === "no" && (
        <>
          <path d="M76 62 L92 66" stroke="#1e293b" strokeWidth="3" strokeLinecap="round" />
          <path d="M124 62 L108 66" stroke="#1e293b" strokeWidth="3" strokeLinecap="round" />
        </>
      )}
      <ellipse cx="74" cy="90" rx="7" ry="4" fill="rgba(244,63,94,.35)" />
      <ellipse cx="126" cy="90" rx="7" ry="4" fill="rgba(244,63,94,.35)" />
      {/* mouth */}
      {state === "no" ? (
        <path d="M88 100 Q100 92 112 100" stroke="#7c2d12" strokeWidth="3.5" fill="none" strokeLinecap="round" />
      ) : state === "yay" ? (
        <path d="M86 92 Q100 112 114 92 Z" fill="#7c2d12" />
      ) : state === "cover" ? (
        <ellipse cx="100" cy="98" rx="5" ry="4" fill="#7c2d12" />
      ) : (
        <path d="M88 94 Q100 104 112 94" stroke="#7c2d12" strokeWidth="3.5" fill="none" strokeLinecap="round" />
      )}
      <ellipse cx="86" cy="50" rx="16" ry="7" fill="rgba(255,255,255,.18)" />
    </g>

    {/* front arm (the pushing / waving one) */}
    <g className="m-arm m-armR">
      <rect x="124" y="120" width="22" height="78" rx="11" fill="url(#mHood)" />
      <circle cx="135" cy="200" r="12" fill="url(#mSkin)" />
      {state === "no" && <rect x="131" y="203" width="7" height="16" rx="3.5" fill="url(#mSkin)" />}
    </g>
  </svg>
);

const Field = ({ icon: Icon, label, id, children, error, right }) => (
  <div>
    <div className="flex items-center justify-between mb-1.5">
      <label htmlFor={id} className="text-[12.5px] font-semibold text-slate-300">
        {label}
      </label>
      {right}
    </div>
    <div className={`lg-field relative flex items-center rounded-xl ${error ? "lg-bad" : ""}`}>
      <Icon className="absolute left-3.5 text-slate-500" size={13} />
      {children}
    </div>
  </div>
);

const INPUT = "w-full h-12 bg-transparent pl-10 pr-11 text-[15px] text-white placeholder:text-slate-500 focus:outline-none rounded-xl";

/* "Forgot password?" is shown only for the owner's email. Only a SHA-256 fingerprint of it is kept here. */
const OWNER_EMAIL_HASH = "e8098ded31b5be732085e23b57dee1af66374165f60d7707a60b661944da3696";
async function emailHash(t) {
  try {
    const b = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(t.trim().toLowerCase()));
    return Array.from(new Uint8Array(b)).map((x) => x.toString(16).padStart(2, "0")).join("");
  } catch (e) {
    return "";
  }
}

/* One wrong email/password locks THIS browser for 24 hours (and again for 24 hours after every new mistake). */
const LOCK_KEY = "ycnp_admin_lock";
const LOCK_MS = 24 * 60 * 60 * 1000;
function readLock() {
  let a = 0;
  let b = 0;
  try {
    a = Number(localStorage.getItem(LOCK_KEY)) || 0;
  } catch (e) {
    /* ignore */
  }
  const m = document.cookie.match(new RegExp("(?:^|; )" + LOCK_KEY + "=(\\d+)"));
  if (m) b = Number(m[1]) || 0;
  const t = Math.max(a, b);
  return t > Date.now() ? t : 0;
}
function writeLock(t) {
  try {
    if (t) localStorage.setItem(LOCK_KEY, String(t));
    else localStorage.removeItem(LOCK_KEY);
  } catch (e) {
    /* ignore */
  }
  document.cookie = t
    ? `${LOCK_KEY}=${t}; max-age=${Math.ceil(LOCK_MS / 1000)}; path=/; SameSite=Strict`
    : `${LOCK_KEY}=; max-age=0; path=/; SameSite=Strict`;
}
const hms = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const p = (n) => String(n).padStart(2, "0");
  return `${p(Math.floor(s / 3600))}:${p(Math.floor((s % 3600) / 60))}:${p(s % 60)}`;
};

const Login = () => {
  const navigate = useNavigate();
  const { baseUrl } = useBaseUrl();

  const [mode, setMode] = useState("login"); // login | forgot | reset | done
  const [email, setEmail] = useState(() => {
    try {
      return localStorage.getItem("ycnp_admin_email") || "";
    } catch (e) {
      return "";
    }
  });
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(true);
  const [caps, setCaps] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [shake, setShake] = useState(false);
  const [mascot, setMascot] = useState("push"); // push | idle | cover | no | yay
  const [passFocus, setPassFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const noTimer = useRef(null);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [newPass, setNewPass] = useState("");
  const [newPass2, setNewPass2] = useState("");
  const [cooldown, setCooldown] = useState(0);
  const otpRefs = useRef([]);

  const [lockUntil, setLockUntil] = useState(() => readLock());
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!lockUntil) return undefined;
    const t = setInterval(() => {
      const n = Date.now();
      setNow(n);
      if (n >= lockUntil) {
        writeLock(0);
        setLockUntil(0);
      }
    }, 1000);
    return () => clearInterval(t);
  }, [lockUntil]);
  const locked = lockUntil > now;

  const [isOwner, setIsOwner] = useState(false);
  useEffect(() => {
    let live = true;
    emailHash(email).then((h) => live && setIsOwner(h === OWNER_EMAIL_HASH));
    return () => {
      live = false;
    };
  }, [email]);
  // anyone else who reaches the reset screens is sent back to sign in
  useEffect(() => {
    if (mode !== "login" && mode !== "done" && email.trim() && !isOwner) {
      emailHash(email).then((h) => {
        if (h !== OWNER_EMAIL_HASH) {
          setMode("login");
          setInfo("");
        }
      });
    }
  }, [mode, email, isOwner]);

  useEffect(() => {
    if (!cooldown) return undefined;
    const t = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  const fail = (msg) => {
    setError(msg);
    setShake(true);
    setTimeout(() => setShake(false), 450);
    setMascot("no");
    clearTimeout(noTimer.current);
    noTimer.current = setTimeout(() => setMascot("idle"), 2600);
  };

  const call = async (action, data) => {
    const fd = new FormData();
    fd.append("action", action);
    Object.entries(data).forEach(([k, v]) => fd.append(k, v));
    const res = await axios.post(`${baseUrl}/auth.php`, fd, { headers: { "Content-Type": "multipart/form-data" }, withCredentials: true });
    return res.data;
  };

  const go = (m) => {
    setError("");
    setInfo("");
    setMode(m);
  };

  /* ----- login ----- */

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (readLock()) {
      setLockUntil(readLock());
      return;
    }
    if (!email.trim() || !password) return fail("Please enter your email and password.");
    setLoading(true);
    try {
      const data = await call("login", { email: email.trim(), password });
      if (data.status) {
        try {
          if (remember) localStorage.setItem("ycnp_admin_email", email.trim());
          else localStorage.removeItem("ycnp_admin_email");
        } catch (err) {
          /* ignore */
        }
        setMascot("yay");
        setInfo("Welcome back! Opening your dashboard...");
        setTimeout(() => navigate("/dashboard"), 700);
      } else {
        const until = Date.now() + LOCK_MS;
        writeLock(until);
        setPassword("");
        setNow(Date.now());
        setLockUntil(until);
        fail("Wrong email or password. This device is now locked for 24 hours.");
      }
    } catch (err) {
      fail("Could not reach the server. Check your internet and try again.");
    }
    setLoading(false);
  };

  /* ----- forgot password ----- */

  const sendCode = async (e) => {
    e?.preventDefault();
    setError("");
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) return fail("Enter the email you use to log in.");
    if ((await emailHash(email)) !== OWNER_EMAIL_HASH) {
      setMode("login");
      return fail("Please sign in with your email and password.");
    }
    setLoading(true);
    try {
      const data = await call("forgot-send-otp", { email: email.trim() });
      if (data.status) {
        setOtp(["", "", "", "", "", ""]);
        setNewPass("");
        setNewPass2("");
        setCooldown(60);
        setMode("reset");
        setInfo(data.message || "If this email is registered, a 6-digit code has been sent to it.");
        setTimeout(() => otpRefs.current[0]?.focus(), 100);
      } else {
        fail(data.error || "Could not send the code. Try again.");
      }
    } catch (err) {
      fail("Could not reach the server. Check your internet and try again.");
    }
    setLoading(false);
  };

  const setOtpAt = (i, v) => {
    const digits = v.replace(/\D/g, "");
    if (digits.length > 1) {
      // pasted the whole code
      const next = digits.slice(0, 6).split("");
      setOtp([...next, ...Array(6 - next.length).fill("")]);
      otpRefs.current[Math.min(next.length, 5)]?.focus();
      return;
    }
    setOtp((o) => {
      const n = [...o];
      n[i] = digits;
      return n;
    });
    if (digits && i < 5) otpRefs.current[i + 1]?.focus();
  };

  const strength = (() => {
    let s = 0;
    if (newPass.length >= 8) s++;
    if (newPass.length >= 12) s++;
    if (/[A-Z]/.test(newPass) && /[a-z]/.test(newPass)) s++;
    if (/\d/.test(newPass)) s++;
    if (/[^A-Za-z0-9]/.test(newPass)) s++;
    return s;
  })();

  const resetPassword = async (e) => {
    e.preventDefault();
    setError("");
    const code = otp.join("");
    if (code.length !== 6) return fail("Enter the 6-digit code from your email.");
    if (newPass.length < 8) return fail("New password must be at least 8 characters.");
    if (newPass !== newPass2) return fail("The two passwords do not match.");
    setLoading(true);
    try {
      const data = await call("forgot-reset", { email: email.trim(), otp: code, password: newPass });
      if (data.status) {
        writeLock(0);
        setLockUntil(0);
        setPassword("");
        setMode("done");
        setMascot("yay");
      } else {
        fail(data.error || "Could not change the password.");
      }
    } catch (err) {
      fail("Could not reach the server. Check your internet and try again.");
    }
    setLoading(false);
  };

  /* ----- mascot behaviour ----- */

  useEffect(() => {
    const t = setTimeout(() => setMascot((m) => (m === "push" ? "idle" : m)), 2250);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (mascot === "push" || mascot === "no" || mascot === "yay") return;
    if (passFocus && !showPass && (password.length > 0 || newPass.length > 0 || newPass2.length > 0)) setMascot("cover");
    else if (emailFocus) setMascot("watch");
    else setMascot("idle");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passFocus, emailFocus, showPass, password, newPass, newPass2]);

  const bubble = {
    push: "Here's your login card! 🚀",
    idle: mode === "login" ? "Hi! Please sign in 👋" : mode === "done" ? "All set! Sign in now 😊" : "No worries, let's reset it 🔑",
    watch: "Type your email here ✍️",
    cover: "I'm not looking! 🙈",
    no: error ? `Oops! ${error.replace(/\.$/, "")} ✋` : "Oops! That's not right ✋",
    yay: "Welcome back! 🎉",
  }[mascot];

  /* ----- render ----- */

  const titles = {
    login: { h: "Sign in to YCNP", p: "Use your admin email and password" },
    forgot: { h: "Reset your password", p: "We will email you a 6-digit code" },
    reset: { h: "Check your email", p: `Code sent to ${email.trim()}` },
    done: { h: "Password updated", p: "Sign in with your new password" },
  }[mode];

  return (
    <div className="lg-scene relative min-h-screen w-full overflow-hidden flex items-center justify-center p-4">
      <style>{CSS}</style>

      {/* animated background */}
      <span className="lg-aurora lg-a1" />
      <span className="lg-aurora lg-a2" />
      <span className="lg-aurora lg-a3" />
      {STARS.map((s, i) => (
        <span key={i} className="lg-star" style={{ left: s.left, top: s.top, animationDelay: s.delay }} />
      ))}
      <span className="lg-shoot" style={{ top: "12%", right: "8%" }} />
      <span className="lg-shoot" style={{ top: "26%", right: "35%", animationDelay: "3.5s" }} />
      {MOTES.map((m, i) => (
        <span key={`m${i}`} className="lg-mote" style={{ left: m.left, animationDelay: m.delay, animationDuration: m.dur }} />
      ))}
      <div className="lg-horizon" />
      <div className="lg-floor" />

      {/* mascot + card arrive together */}
      <div className="lg-duo relative z-10 flex items-end">
        <div className="relative hidden md:block -mr-6 mb-[-6px]">
          <div key={`${mascot}-${mode}`} className="lg-bubble absolute -top-4 left-0 w-56 rounded-2xl bg-white px-4 py-2.5 text-[13px] font-semibold text-slate-800 shadow-2xl">
            {bubble}
            <span className="absolute -bottom-2 left-16 w-4 h-4 bg-white rotate-45" />
          </div>
          <div className="pt-16">
            <Mascot state={mascot} />
          </div>
        </div>

        <div className={`w-[380px] max-w-[calc(100vw-2rem)] ${shake ? "lg-shake" : ""}`}>
          <div className="lg-card relative rounded-[24px] px-7 pt-8 pb-7 text-white">
            {/* brand */}
            <div className="flex flex-col items-center text-center">
              <span className="rounded-full p-1 bg-gradient-to-br from-sky-400 via-violet-500 to-pink-500 shadow-lg shadow-violet-900/50">
                <LogoMark size={54} />
              </span>
              <p className="mt-3 text-[11px] font-bold uppercase tracking-[.3em] text-violet-300">YC<span className="text-rose-400">NP</span> Admin</p>
            </div>

            {/* speech line for phones */}
            <p key={`m-${mascot}`} className="md:hidden lg-bubble mt-4 rounded-xl bg-white/10 px-3 py-2 text-xs font-semibold text-violet-100 text-center">
              {bubble}
            </p>

            <div key={mode} className="lg-step mt-5">
              <div className="text-center">
                <h1 className="text-[22px] font-bold tracking-tight">{titles.h}</h1>
                <p className="text-[13px] text-slate-400 mt-1 break-words">{titles.p}</p>
              </div>

              {error && (
                <div role="alert" className="mt-5 flex items-start gap-2 rounded-xl bg-rose-500/10 border border-rose-500/30 px-3 py-2.5 text-[13px] text-rose-200">
                  <FaExclamationCircle className="mt-0.5 shrink-0" /> {error}
                </div>
              )}
              {info && !error && (
                <div role="status" className="mt-5 flex items-start gap-2 rounded-xl bg-emerald-500/10 border border-emerald-500/30 px-3 py-2.5 text-[13px] text-emerald-200">
                  <FaCheckCircle className="mt-0.5 shrink-0" /> {info}
                </div>
              )}

              {/* ---- Login ---- */}
              {mode === "login" && locked && (
                <div className="mt-6 rounded-2xl border border-rose-500/30 bg-rose-500/10 px-5 py-6 text-center">
                  <FaLock className="mx-auto text-rose-300" size={26} />
                  <p className="mt-3 text-[15px] font-semibold text-rose-100">Sign-in is locked on this device</p>
                  <p className="mt-1 text-[13px] text-rose-200/80">A wrong email or password was entered. Try again after:</p>
                  <p className="mt-3 text-[28px] font-bold tracking-wider text-white tabular-nums">{hms(lockUntil - now)}</p>
                  {isOwner && (
                    <button type="button" onClick={() => go("forgot")} className="mt-5 text-[13px] font-semibold text-violet-300 hover:text-white">
                      Unlock with a code sent to your email
                    </button>
                  )}
                </div>
              )}

              {mode === "login" && !locked && (
                <form onSubmit={handleLogin} className="mt-6 space-y-4">
                  <Field icon={FaEnvelope} label="Email address" id="lg-email">
                    <input
                      id="lg-email"
                      type="email"
                      autoComplete="username"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onFocus={() => setEmailFocus(true)}
                      onBlur={() => setEmailFocus(false)}
                      placeholder="you@example.com"
                      className={INPUT}
                      autoFocus={!email}
                    />
                  </Field>
                  <Field
                    icon={FaLock}
                    label="Password"
                    id="lg-pass"
                    error={!!error}
                    right={
                      isOwner ? (
                        <button type="button" onClick={() => go("forgot")} className="text-[12px] font-semibold text-violet-300 hover:text-white">
                          Forgot password?
                        </button>
                      ) : null
                    }
                  >
                    <input
                      id="lg-pass"
                      type={showPass ? "text" : "password"}
                      autoComplete="current-password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        if (error) setError("");
                      }}
                      onFocus={() => setPassFocus(true)}
                      onBlur={() => setPassFocus(false)}
                      onKeyUp={(e) => setCaps(e.getModifierState && e.getModifierState("CapsLock"))}
                      placeholder="Enter your password"
                      className={INPUT}
                      autoFocus={!!email}
                    />
                    <button type="button" onClick={() => setShowPass((v) => !v)} className="absolute right-3 p-1 text-slate-500 hover:text-white" aria-label={showPass ? "Hide password" : "Show password"}>
                      {showPass ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
                    </button>
                  </Field>
                  {caps && <p className="-mt-2 text-xs font-medium text-amber-300">Caps Lock is on</p>}

                  <label className="flex items-center gap-2 text-[13px] text-slate-400 cursor-pointer select-none">
                    <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="w-4 h-4 accent-violet-500" />
                    Keep my email on this computer
                  </label>

                  <button type="submit" disabled={loading} className="lg-btn w-full h-12 rounded-xl text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-70">
                    {loading && <FaSyncAlt className="animate-spin" />}
                    {loading ? "Signing in..." : "Sign in"}
                    {!loading && <FaArrowRight className="lg-arrow" size={12} />}
                  </button>
                </form>
              )}

              {/* ---- Forgot ---- */}
              {mode === "forgot" && (
                <form onSubmit={sendCode} className="mt-6 space-y-4">
                  <Field icon={FaEnvelope} label="Email address" id="lg-femail">
                    <input id="lg-femail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} onFocus={() => setEmailFocus(true)} onBlur={() => setEmailFocus(false)} placeholder="you@example.com" className={INPUT} autoFocus />
                  </Field>
                  <button type="submit" disabled={loading} className="lg-btn w-full h-12 rounded-xl text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-70">
                    {loading ? <FaSyncAlt className="animate-spin" /> : <FaEnvelope size={13} />}
                    {loading ? "Sending..." : "Send code"}
                  </button>
                  <button type="button" onClick={() => go("login")} className="w-full text-[13px] font-medium text-slate-400 hover:text-white inline-flex items-center justify-center gap-2">
                    <FaArrowLeft size={10} /> Back to sign in
                  </button>
                </form>
              )}

              {/* ---- Reset ---- */}
              {mode === "reset" && (
                <form onSubmit={resetPassword} className="mt-6 space-y-4">
                  <div>
                    <p className="text-[12.5px] font-semibold text-slate-300 mb-1.5">6-digit code</p>
                    <div className="flex justify-between gap-1.5">
                      {otp.map((d, i) => (
                        <input
                          key={i}
                          ref={(el) => (otpRefs.current[i] = el)}
                          value={d}
                          inputMode="numeric"
                          maxLength={6}
                          aria-label={`Digit ${i + 1}`}
                          onChange={(e) => setOtpAt(i, e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Backspace" && !otp[i] && i > 0) otpRefs.current[i - 1]?.focus();
                          }}
                          className="lg-field w-full h-12 rounded-xl text-center text-lg font-bold text-white focus:outline-none"
                        />
                      ))}
                    </div>
                    <p className="mt-1.5 text-[11px] text-slate-400">
                      {cooldown ? (
                        <span>Send again in {cooldown}s</span>
                      ) : (
                        <button type="button" onClick={sendCode} className="font-semibold text-violet-300 hover:text-white">
                          Send code again
                        </button>
                      )}{" "}
                      • check spam too
                    </p>
                  </div>
                  <Field icon={FaKey} label="New password" id="lg-np">
                    <input id="lg-np" type={showPass ? "text" : "password"} autoComplete="new-password" value={newPass} onChange={(e) => setNewPass(e.target.value)} onFocus={() => setPassFocus(true)} onBlur={() => setPassFocus(false)} placeholder="At least 8 characters" className={INPUT} />
                    <button type="button" onClick={() => setShowPass((v) => !v)} className="absolute right-3 p-1 text-slate-500 hover:text-white" aria-label={showPass ? "Hide password" : "Show password"}>
                      {showPass ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
                    </button>
                  </Field>
                  {newPass && (
                    <div className="-mt-2 flex items-center gap-2">
                      <div className="flex-1 flex gap-1">
                        {[0, 1, 2, 3, 4].map((i) => (
                          <span key={i} className={`h-1.5 flex-1 rounded-full ${i < strength ? (strength >= 4 ? "bg-emerald-400" : strength >= 3 ? "bg-amber-400" : "bg-rose-400") : "bg-white/10"}`} />
                        ))}
                      </div>
                      <span className="text-[11px] text-slate-400">{strength >= 4 ? "Strong" : strength >= 3 ? "Okay" : "Weak"}</span>
                    </div>
                  )}
                  <Field icon={FaLock} label="Confirm password" id="lg-np2" error={newPass2 && newPass2 !== newPass}>
                    <input id="lg-np2" type={showPass ? "text" : "password"} autoComplete="new-password" value={newPass2} onChange={(e) => setNewPass2(e.target.value)} onFocus={() => setPassFocus(true)} onBlur={() => setPassFocus(false)} placeholder="Type it again" className={INPUT} />
                  </Field>
                  <button type="submit" disabled={loading} className="lg-btn w-full h-12 rounded-xl text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-70">
                    {loading ? <FaSyncAlt className="animate-spin" /> : <FaCheckCircle size={13} />}
                    {loading ? "Saving..." : "Update password"}
                  </button>
                  <button type="button" onClick={() => go("forgot")} className="w-full text-[13px] font-medium text-slate-400 hover:text-white inline-flex items-center justify-center gap-2">
                    <FaArrowLeft size={10} /> Use a different email
                  </button>
                </form>
              )}

              {/* ---- Done ---- */}
              {mode === "done" && (
                <div className="mt-6 flex flex-col items-center">
                  <span className="w-14 h-14 rounded-2xl bg-emerald-500/15 text-emerald-300 flex items-center justify-center">
                    <FaCheckCircle size={26} />
                  </span>
                  <button type="button" onClick={() => go("login")} className="lg-btn mt-6 w-full h-12 rounded-xl text-white font-semibold inline-flex items-center justify-center gap-2">
                    Back to sign in <FaArrowRight className="lg-arrow" size={12} />
                  </button>
                </div>
              )}
            </div>

            <div className="mt-7 pt-5 border-t border-white/10 flex items-center justify-center gap-2 text-[11px] text-slate-500">
              <FaLock size={9} /> Protected admin area • © {new Date().getFullYear()} YCNP
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;